import PropTypes from 'prop-types';

export const promoComponentPropTypes = {
	additionalDetails: PropTypes.string,
	autoGenerated: PropTypes.bool,
	condition: PropTypes.string,
	couponCode: PropTypes.string,
	customAssets: PropTypes.shape(),
	destinationLabel: PropTypes.string,
	destinationUrl: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	disclaimer: PropTypes.string,
	discountType: PropTypes.string,
	discountValue: PropTypes.number,
	globalVehicleId: PropTypes.string,
	id: PropTypes.string.isRequired,
	imageUrl: PropTypes.string,
	incentiveId: PropTypes.string,
	inventoryCount: PropTypes.number,
	type: PropTypes.string.isRequired,
	vehicleImages: PropTypes.arrayOf(PropTypes.string),
	oemId: PropTypes.string,
	ctaConfig: PropTypes.shape({
		openInNewTab: PropTypes.bool
	}),
	incentiveData: PropTypes.shape({
		id: PropTypes.string,
		applicableCondition: PropTypes.string,
		applicableMake: PropTypes.string,
		incentive: PropTypes.shape({
			type: PropTypes.string
		}),
		incentiveEffectiveDate: PropTypes.string,
		incentiveExpirationDate: PropTypes.string,
		globalVehicleId: PropTypes.string,
		globalVehicleTrimIds: PropTypes.arrayOf(PropTypes.string)
	})
};
